<template>
  <div>
    <el-tooltip v-if="canToggle" :content="actionText" effect="light" placement="top" :open-delay="400">
      <button
          class="btn btn-sm"
          :class="{'btn-secondary': !isBound, 'btn-danger': isBound}"
          @click="toggle"
      >
        <i class="fas fa-link"></i>
      </button>
    </el-tooltip>
    <el-tooltip v-else-if="isBound" effect="light" content="Attached" placement="top" :open-delay="400">
      <i class="fas fa-link"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {Boolean}
     */
    canToggle() {
      return _.get(this.row, 'can_toggle', false);
    },

    /**
     * @return {bool}
     */
    isBound() {
      return _.get(this.row, 'is_bound', false);
    },

    /**
     * @return {string}
     */
    actionText() {
      return this.isBound ? 'Detach' : 'Attach';
    },
  },

  methods: {
    /**
     * @event toggle
     */
    toggle() {
      this.$emit('toggle', {row: this.row});
    },
  },
}
</script>
